module.exports = __webpack_public_path__ + "assets/img/4148866c68d7ccf23de9c988261b4cd1.svg";